var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoal = function SvgCoal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.94 12.06A8.004 8.004 0 0 0 39 5a8.1 8.1 0 0 0-2.34.35A7.97 7.97 0 0 0 31 3a8.05 8.05 0 0 0-7.42 5.02C23.39 8.01 23.19 8 23 8a8.05 8.05 0 0 0-7.48 5.16A6.94 6.94 0 0 0 10.69 17h42.72a8.02 8.02 0 0 0-6.47-4.94M11.05 50.92c-.03-.3-.05-.61-.05-.92a9 9 0 0 1 18 0 8 8 0 0 1-.06 1h6.12a8 8 0 0 1-.06-1 9 9 0 0 1 18 0c0 .31-.02.62-.05.92A5.994 5.994 0 0 0 58 45V20a1.003 1.003 0 0 0-1-1H7a1.003 1.003 0 0 0-1 1v25a5.994 5.994 0 0 0 5.05 5.92"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 50,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 50,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55H48.89a7 7 0 1 0-9.78 0H24.89a7 7 0 1 0-9.78 0H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h62a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-19-9a4 4 0 1 1-4 4 4.004 4.004 0 0 1 4-4m-24 0a4 4 0 1 1-4 4 4.004 4.004 0 0 1 4-4"
  })));
};
export default SvgCoal;